module.exports = __webpack_public_path__ + "static/media/hw_ro_43.76868e89.flv";